import { 
  usdtContract,
  safeContract, islConAdd, dlvContract,
  dlvConAdd,
  spp2lvConAdd,
  slvConAdd1,
  slvConAdd2,
  slvConAdd3,
  slvConAdd4

        } from "./ConAddsAndABIs"
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";

function TheDipLadderVault(){

const [buySafeValue, setBuySafeValue] = useState(""); 
const [remainingSafe, setRemainingSafe] = useState('');
const [safeSold, setSafeSold] = useState('');
const [usdcGenerated, setUsdcGenerated] = useState('');
const [usdcBacking, setUsdcBacking] = useState('');
const [circulatingSupply, setCirculatingSupply] = useState('');


useEffect(() => {  
 
// - - - - - - - - - - 
const getTotalUsdtRewards = async () => {
    const a = await dlvContract.getDlvSellingPrice() / 1000000;
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const c = await dlvContract.totalSafeBought() / 1
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const e = await dlvContract.totalUSDTRedeemed() / 1
    const f = e.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})  
    const g = await usdtContract.balanceOf(dlvConAdd) / (10 ** 6)
    const h = g.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0}) 
    const i = await safeContract.totalSupply() / (10 ** 18)
    const j = await safeContract.balanceOf(islConAdd) / (10 ** 18)
    const k = await safeContract.balanceOf(spp2lvConAdd) / (10 ** 18)
    const l = await safeContract.balanceOf(slvConAdd1) / (10 ** 18)
    const m = await safeContract.balanceOf(slvConAdd2) / (10 ** 18)
    const n = await safeContract.balanceOf(slvConAdd3) / (10 ** 18)
    const o = await safeContract.balanceOf(slvConAdd4) / (10 ** 18)
    const p = i - j - k - l - m - n - o
    const q = p.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})                                                                                                                                                                                           
    setRemainingSafe(b) //Bottom price
    setSafeSold(d) //Safe bought back
    setUsdcGenerated(f) //USDC claimed
    setUsdcBacking(h)
    setCirculatingSupply(q)


  }  

  getTotalUsdtRewards()
  .catch(console.error)


})

const handleBuySafeValueChange = (e) => {
    setBuySafeValue(e.target.value);
    }  
   
const handleBuySafeValueSubmit = async (e) => {
    e.preventDefault();
    console.log(buySafeValue)
    const txn = ethers.utils.parseUnits(buySafeValue, 18)
    const txna = await safeContract.approve(dlvConAdd, txn)
    await txna.wait();  
    const txnb = await dlvContract.sellSafeToDlv(buySafeValue)
    await txnb.wait();
    setBuySafeValue(0);
    }

return ( 
  <div>
        <h2>The Dip Ladder Vault</h2><br/>

        <form style={{"textAlign": "center"}} onSubmit={handleBuySafeValueSubmit}>
            <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleBuySafeValueChange} value={buySafeValue} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Sell $SAFE for {remainingSafe} USDC each</button>
        </form><br/> 

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Global Metrics</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Bottom Price</td>
                <td className="column2">{remainingSafe} $SAFE</td>
            </tr>
            <tr>
                <td>Total Backing</td>
                <td className="column2">{usdcBacking} $USDC</td>
            </tr>  
            <tr>
                <td>Total Circulating Supply</td>
                <td className="column2">{circulatingSupply} $SAFE</td>
            </tr>                         
            <tr>
                <td>Total SAFE Bought Back</td>
                <td className="column2">{safeSold} $SAFE</td>
            </tr>   
            <tr>
                <td>Total USDC Paid</td>
                <td className="column2">{usdcGenerated} $USDC</td>
            </tr>                                                                                                                           
        </tbody>               
      </table><br />
  

  </div>
  
)

}


export default TheDipLadderVault;